document.addEventListener('DOMContentLoaded', function () {
  if (!window.mz || !window.mz.enabled) {
    return
  }

  var toggleMobileSearch = function (event) {
    var ctrl = $('.mz-sticky-search-mobile input')
    var className = 'mz-sticky-open'
    if (ctrl.hasClass(className)) {
      ctrl.removeClass(className)
    } else {
      ctrl.addClass(className)
    }
    event.preventDefault()
  }

  $('.mz-sticky-search-mobile .site-nav__link').on('click', toggleMobileSearch)
})
